export default __webpack_public_path__ + "static/media/cdsadminmgr-hover.aa8074bd.svg";